import CompanyPricesApi from './Api'

// only override all for AdminTable compatability
export default class CityTaxiPricingApi extends CompanyPricesApi {
  all() {
    return super.getCityTaxiPricingIndex({})
  }
  destroy(params) {
    return super.deleteCityTaxiPricing(params)
  }
}
